import { usePushSubscription } from 'server';

/**
 * Event used for Leaderboard integration
 * Subscription type 'leaderboard-message' must be configured to receive this notifications.
 * @memberOf Playtech.API.events
 * @event leaderboard-message
 * @type {callback}
 * @example Playtech.on('leaderboard-message', () => { ... });
 */

export const EVENT_LEADERBOARD_MESSAGE = 'leaderboard-message';

export const useOnLeaderboardMessage = (eventTarget: EventTarget) => {
    usePushSubscription([
        73006, 73016, 73030, 71031, 71032, 73033, 73036
    ], () => response => {
        const event = new CustomEvent(EVENT_LEADERBOARD_MESSAGE, { detail: response });

        eventTarget.dispatchEvent(event);
    });
};
